module.exports = __webpack_public_path__ + "static/media/t4.b6451bc5.png";